import TextureIntensityPqChart from './TextureIntensityPqChart';
export default TextureIntensityPqChart;
